// extracted by mini-css-extract-plugin
export default {"auxTag":"SectionHeading_auxTag__KilmQ"};